import { APP_ROUTES } from '../../../app-routes';

export const SHIFT_ROUTES = {
  List: '',
  Detail: ':id'
};

const BASE = APP_ROUTES.Shifts;
export const ShiftPaths = {
  List: `/${BASE}`,
  Detail: (id: string) => `/${BASE}/${id}`
};
